<template>
  <div>
    <a
      class="download-button"
      :href="normalizedUrl"
      :download="normalizedFileName"
      v-if="downloadable"
    >
      <inline-svg
        :src="require(`@/assets/icons/pdf-file.svg`)"
        class="download-button__icon"
      />
      <slot></slot>
    </a>
    <a class="download-button" v-else v-on="$listeners">
      <inline-svg
        :src="require(`@/assets/icons/pdf-file.svg`)"
        class="download-button__icon"
      />
      <slot></slot>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    digest: {
      type: Object,
    },
    downloadable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    normalizedUrl() {
      return this.digest.upload_short;
    },
    normalizedFileName() {
      return `${this.digest.short_description}-${this.digest.group_month}-${this.digest.group_year}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.download-button {
  display: flex;
  align-items: center;
  cursor: pointer;
  text-decoration: none;
  color: #00557c;
  &:hover {
    color: #033a53;
  }
  &__icon {
    margin-right: 12px;
  }
}
</style>
